import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading")
  const _component_RouterView = _resolveComponent("RouterView")
  const _component_VerticalButtonDialog = _resolveComponent("VerticalButtonDialog")
  const _component_HorizontalButtonDialog = _resolveComponent("HorizontalButtonDialog")
  const _component_Toast = _resolveComponent("Toast")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Loading),
    (_ctx.isLoaded)
      ? (_openBlock(), _createBlock(_component_RouterView, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isVerticalDialogVisible)
      ? (_openBlock(), _createBlock(_component_VerticalButtonDialog, _mergeProps({ key: 1 }, _ctx.dialog, {
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.emitter.emit(_ctx.DialogEvent.CLICK, $event))),
          onClose: _cache[2] || (_cache[2] = $event => (_ctx.isVerticalDialogVisible = false))
        }), null, 16))
      : _createCommentVNode("", true),
    (_ctx.isHorizontalDialogVisible)
      ? (_openBlock(), _createBlock(_component_HorizontalButtonDialog, _mergeProps({ key: 2 }, _ctx.dialog, {
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.emitter.emit(_ctx.DialogEvent.CLICK, $event))),
          onClose: _cache[4] || (_cache[4] = $event => (_ctx.isHorizontalDialogVisible = false))
        }), null, 16))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast)
  ], 64 /* STABLE_FRAGMENT */))
}